// extracted by mini-css-extract-plugin
export var tablet_min = "768px";
export var desktop_min_sm = "992px";
export var desktop_min = "1100px";
export var desktop_min_lg = "1220px";
export var popup_breakpoint = "1399px";
export var container = "p_T";
export var containerBlock = "p_Z";
export var containerRow = "p_0";
export var itemchild = "p_1";
export var socialRow = "p_2";
export var itemIcon = "p_3";